export default {
    url: '/matrix',
    template: '<reports-matrix/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/reports/matrix/index.js